import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'

import App from '@/App'
import '@/i18n'
import { initTheme } from '@/lib/theme'
import '@/styles/index.css'

initTheme()

// Οι ανανεώσεις έρχονται από WebSocket invalidation, όχι από polling (§9).
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
)

// PWA: ο service worker δίνει offline shell και παραλαμβάνει τα Web Push (§3).
// Η αποτυχία δεν είναι κρίσιμη — η εφαρμογή λειτουργεί κανονικά και χωρίς αυτόν.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch(() => undefined)
  })
}
